// Centralized site content for Stride & Stone Equine
export const BRAND = {
  name: "Stride & Stone Equine",
  tagline: "Equine Sports Massage Therapy",
  logo: "https://customer-assets.emergentagent.com/job_service-finder-522/artifacts/r6u30166_IMG_7762.jpg",
};

export const IMAGES = {
  heroMassage: "/photos/photo4.jpg",
  horseNeck: "/photos/photo1.jpg",
  therapyStable: "/photos/photo2.jpg",
  dressage: "/photos/photo3.jpg",
  fieldGolden: "/photos/photo4.jpg",
};

export const BENEFITS = [
  {
    title: "Relieves muscular tension",
    body: "Eases tightness and trigger points that build up through training, competition, and everyday work.",
  },
  {
    title: "Improves range of motion",
    body: "Restores suppleness so your horse moves freely, evenly, and with greater comfort under saddle.",
  },
  {
    title: "Supports recovery",
    body: "Boosts circulation and lymphatic flow to help muscles recover faster after exertion or injury.",
  },
  {
    title: "Enhances performance",
    body: "A balanced, comfortable body translates to better stride quality, willingness, and longevity.",
  },
  {
    title: "Early issue detection",
    body: "Regular hands-on evaluation helps catch asymmetry and discomfort before they become problems.",
  },
  {
    title: "Calmer temperament",
    body: "Releasing physical tension settles the nervous system, leaving many horses noticeably more relaxed.",
  },
];

export const PROCESS = [
  {
    step: "01",
    title: "Consultation & evaluation",
    body: "We start with your horse's history, workload, and any concerns, followed by a gentle static and dynamic evaluation to read posture, gait, and muscle condition.",
  },
  {
    step: "02",
    title: "Full body massage",
    body: "A complete, tailored full-body treatment using sports massage techniques to address tension, asymmetry, and restricted movement, working at a pace your horse is comfortable with.",
  },
  {
    step: "03",
    title: "Aftercare & plan",
    body: "You'll receive clear aftercare guidance and simple stretches, plus a recommended treatment rhythm to keep your horse feeling and performing at their best.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "After just one full-body session my mare was moving more freely than she had in months. The change in her canter was unmistakable.",
    name: "Hannah W.",
    role: "Dressage rider",
  },
  {
    quote:
      "Calm, knowledgeable, and brilliant with nervous horses. My gelding completely relaxed within minutes and now looks forward to his treatments.",
    name: "Tom R.",
    role: "Eventing barn owner",
  },
  {
    quote:
      "The evaluation picked up tension I hadn't noticed. The aftercare advice was practical and genuinely made a difference to his comfort.",
    name: "Priya S.",
    role: "Happy hacker",
  },
];

export const FAQS = [
  {
    q: "What is equine sports massage?",
    a: "It's a hands-on therapy that uses targeted massage techniques to release muscular tension, improve circulation, and restore range of motion. It supports horses in all disciplines, from competition athletes to much-loved companions.",
  },
  {
    q: "How do I know if my horse would benefit?",
    a: "Signs include stiffness, uneven movement, reluctance under saddle, behavioural changes, or simply a heavy workload. Many owners also book regular maintenance sessions to keep their horse feeling their best.",
  },
  {
    q: "How long does a session take?",
    a: "A full-body treatment, including evaluation and aftercare, typically takes around 60–90 minutes. Your horse sets the pace, so we never rush.",
  },
  {
    q: "Do I need veterinary consent?",
    a: "For non-routine treatment of an injury or specific condition, veterinary consent is required and I'm always happy to liaise with your vet. For maintenance and performance work, we'll confirm everything during booking.",
  },
  {
    q: "Where do treatments take place?",
    a: "Treatments are carried out at your own barn, in your horse's familiar surroundings, so they stay relaxed and comfortable throughout.",
  },
];
